import { InputGroup } from "../../InputGroup-CrlMRz4X.js";
import { useControllableState } from "../../useControllableState-CUYXMsfz.js";
import { jsx } from "react/jsx-runtime";
//#region src/blocks/Textarea/Textarea.tsx
/**
* Multi-line text input. Chrome resolves from the active brand automatically: a modern brand always
* renders argo (any `variant` is ignored), while `variant` only tunes the legacy-brand chrome.
*/
const Textarea = ({ ref, containerClassName, state = "default", variant, sizing, focusVariant, value: valueProp, defaultValue, onValueChange, ...rest }) => {
	const [value, setValue] = useControllableState({
		prop: valueProp === void 0 ? void 0 : valueProp ?? "",
		defaultProp: defaultValue ?? "",
		onChange: onValueChange
	});
	return /* @__PURE__ */ jsx(InputGroup, {
		state,
		sizing,
		focusVariant,
		variant,
		className: containerClassName,
		children: /* @__PURE__ */ jsx(InputGroup.TextArea, {
			...rest,
			ref,
			value,
			onValueChange: setValue
		})
	});
};
//#endregion
export { Textarea };

//# sourceMappingURL=Textarea.js.map